// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__EbRTN","title":"FrontImage_title__TFcEX"};